import React from "react";

const objectivesData = [
  {
    title: "Course Objectives:",
    items: [
      "Develop advanced skills in crafting compelling and informative news articles across diverse topics and platforms.",
      "Master investigative reporting techniques, focusing on accuracy, credibility, and ethical integrity.",
      "Acquire expertise in multimedia storytelling, integrating visual, audio, and digital elements for maximum audience engagement.",
      "Critically evaluate the contemporary media landscape, identifying emerging trends and technological innovations.",
      "Foster leadership, collaboration, and innovation in journalistic practices.",
    ],
    color: "text-green-600",
  },
  {
    title: "Course Outcomes:",
    items: [
      "Demonstrate mastery of news writing, multimedia storytelling, and investigative reporting.",
      "Apply ethical principles to journalistic practices, ensuring integrity, transparency, and impartiality.",
      "Leverage emerging technologies to adapt and innovate in the evolving media landscape.",
      "Critically assess news sources and analyse media bias and credibility.",
      "Collaborate effectively to lead journalistic projects, fostering professionalism and creativity.",
    ],
    color: "text-purple-600",
  },
];

const ObjectivesEJ = () => {
  return (
    <div className="my-10 " id="objectives">
      <div className="max-w-6xl mx-auto bg-sdbodywhite bg-opacity-70 shadow-lg rounded-lg p-8">
  

        <div className="md:flex md:gap-8 space-y-5 md:space-y-0">
          {objectivesData.map((section, index) => (
            <div key={index} className="md:w-1/2">
              <h3
                className={`text-lg md:text-2xl font-semibold mb-4 ${section.color}`}
              >
                {section.title}
              </h3>
              <ul className="space-y-4 list-disc list-inside">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-4">
                    <img
                      src="/image-fix/pointers/inspiration-svgrepo-com.svg"
                      alt="icon"
                      className="w-8 h-8 mt-1"
                    />
                    <span className="text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ObjectivesEJ;
